import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './mst_chnl_conf.html?raw';

import Edit from '../../../../moreCore/UI/Edit/Edit';
import CheckBox from '../../../../moreCore/UI/CheckBox/CheckBox';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';

class mst_chnl_conf extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private nameEdit: MdsLax<InstanceType<typeof Edit>>;
    private descriptionEdit: MdsLax<InstanceType<typeof Edit>>;
    private isArchivedCheck: MdsLax<InstanceType<typeof CheckBox>>;

    private isArchivedCheckContainer:HTMLDivElement;

    private myDlg: MdsLax<InstanceType<typeof GenericDialog>> = null;
    public entity: TeamsChannelApiData = null;
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.nameEdit.setMaxLength(256); //api limit
        this.nameEdit.setLabel(this.translate("General_Label_Displayname"));
        this.descriptionEdit.setIsMultiline(true);
        this.descriptionEdit.setMaxLength(250); //ui enforce limit
        //this.descriptionEdit.on("valueChange", lang.hitch(this, this._onChangeTxt));
        this.descriptionEdit.setLabel(this.translate("MsTeamsIntegration_AdminPanel_ChannelDescription"));
        this.isArchivedCheck.setReadonly(true);
        this.isArchivedCheck.setType('radio');
        this.isArchivedCheck.setLabel(this.translate("MsTeamsIntegration_AdminPanel_ChannelIsArchived"));
        this.isArchivedCheck.setAlignment('iconright');
        this.isArchivedCheckContainer.title = this.translate("MsTeamsIntegration_AdminPanel_Hint_ArchivedStatus");
        this.on("valueChange", lang.hitch(this, this._onChange_Save));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    public setValue(value: TeamsChannelApiData) {
        this.nameEdit.setValue(value.channelDisplayName, true);
        this.descriptionEdit.setValue(value.channelDescription, true);
        if (value.channel_isArchived == true) {
            this.isArchivedCheck.setValue(true, true);
        } else {
            this.isArchivedCheck.setValue(false, true);
        }
        //wenn archiviert dann kann auch nix editiert werden
        if (value.channel_isArchived == true) {
            this.nameEdit.setReadonly(true);
            this.descriptionEdit.setReadonly(true);
        } else {
            this.nameEdit.setReadonly(false);
            this.descriptionEdit.setReadonly(false);
        }
        this.entity = value;
    }

    private _debounceTimeout: number | null = null;

    private _onChangeTxt() {
        if (this._debounceTimeout) {
            clearTimeout(this._debounceTimeout);
        }
        this._debounceTimeout = window.setTimeout(lang.hitch(this, () => {
            let descriptionTxt: string = this.descriptionEdit.getValue();
            let titleTxt: string = this.nameEdit.getValue();
            this.emit("valueChange", { ID: this.entity?.ID, description: descriptionTxt, displayName: titleTxt });
            this._debounceTimeout = null;
        }), 50);
    }

    private async _onChange_Save(changedData: { ID: string, description: string, displayName: string }){
        this.StandbyStart()
        if (this.myDlg != null){
            this.myDlg.disableAllButtons(true);
        }
        let updateValuesPromise: Promise<{ changesWereMade: boolean }> = new Promise((resolve, reject) => {
            this.RequestManager.callfunction(
                "Webtool_API_MS_Teams_Integration_AdminPanel__UpdateChannelObject",
                { entityID: changedData.ID, displayName: changedData.displayName, description: changedData.description },
                lang.hitch(this, (result: any) => {
                    resolve(result);
                }),
                lang.hitch(this, (err) => {
                    console.error(err.Message);
                    this.showToast(err.Message, "fas fa-bug");
                    reject(err);
                })
            );
        });

        let requestResult: { changesWereMade: boolean };
        try {
            requestResult = await updateValuesPromise;
        } catch {
            this.StandbyStop();
            if (this.myDlg != null) {
                this.myDlg.disableAllButtons(false);
            }
            return;
        }
        if (this.myDlg != null) {
            this.myDlg.disableAllButtons(false);
        }
        this.StandbyStop();
        console.info("udpated channel entity", changedData, requestResult);
        this.showToast(this.getTranslation("General_SavingChangesSuccessful"), "far fa-save");
    }

    public hide_IsArchived( isHidden:boolean = true){
        if (isHidden){
            this.isArchivedCheckContainer.classList.add("w3-hide");
        }else{
            this.isArchivedCheckContainer.classList.add("w3-hide");
        }
    }

    public getValue(){
        let descriptionTxt: string = this.descriptionEdit.getValue();
        let titleTxt: string = this.nameEdit.getValue();
        let entity:any = this.entity ?? null;
        return {displayName:titleTxt, description:descriptionTxt, entity:entity};
    }

    destroy(preserveDom?: boolean): void {
        if (this._debounceTimeout != null){
            clearTimeout(this._debounceTimeout);
        }
        super.destroy.apply(this, arguments as any);
    }

    public setReadOnly(isReadOnly: boolean) {
        this.nameEdit.setReadonly(isReadOnly ?? false);
        this.descriptionEdit.setReadonly(isReadOnly ?? false);
    }

    public openInDlg(onSavedCallback?:Function) {
        if (this.myDlg != null){
            try{
                this.myDlg.destroyRecursive();
            }catch{}
        }
        this.myDlg = new GenericDialog();
        this.myDlg.setSize('smaller');
        this.myDlg.destroyOnClose = false;
        this.myDlg.show(
            this,
            this.translate("MsTeamsIntegration_AdminPanel_OpenChannelEditor"),
            null,
            null,
            'saveclose',
            (btnId:number)=>{
                if (btnId != 1){
                    return;
                }

                this._onChangeTxt();

                if (typeof onSavedCallback == 'function'){
                    onSavedCallback();
                }
            }
        );
    }
}

export default mdsWidget(mst_chnl_conf);
